import { render } from "./MaterialList.vue?vue&type=template&id=2a9e43e3&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"

import "./MaterialList.vue?vue&type=style&index=0&id=2a9e43e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9e43e3"]])

export default __exports__